import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import { formatBytes } from '../../Utils/formaters';

const StorageProgressBar = ({ storage }) => {

    const percentageUsed = (storage.usedStorage / storage.storageLimit) * 100;
    const getVariant = (percentage) => {
        if(percentage > 65) return 'warning';
        else if(percentage > 90) return 'danger'
        else return 'primary';
    }

    return (
        <div className="storage-progress-bar">
            <ProgressBar variant={getVariant(percentageUsed)} now={percentageUsed} label={`${percentageUsed.toFixed(2)}%`} />
            <div>
                {formatBytes(storage.usedStorage)} / {formatBytes(storage.storageLimit)} used
            </div>
        </div>
    );
};

export default StorageProgressBar;
